import { useState } from 'react'
import api from '../api'
import { useSelector, useDispatch } from 'react-redux'
import { selectToken, setToken } from './authenticationSlice'

const useConnectProvider = () => {
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const token = useSelector(selectToken)
  const dispatch = useDispatch()

  const ensureValidToken = async () => {
    if (!token?.accessToken || !token?.accessTokenExpiresAt) {
      throw new Error('No valid token available')
    }

    const now = Date.now()
    const expiresAt = new Date(token.accessTokenExpiresAt).getTime()
    const timeUntilExpiry = expiresAt - now

    // Refresh if token expires in < 2 minutes
    if (timeUntilExpiry < 120000) {
      const refreshResponse = await api.post('/auth/refresh_token')
      dispatch(setToken({
        accessToken: refreshResponse.data.access_token,
        accessTokenExpiresAt: refreshResponse.data.access_token_expires_at,
        userId: token.userId
      }))
      return refreshResponse.data.access_token
    }

    return token.accessToken
  }

  const connectProvider = async (data: {
    google_id_token?: string
    google_access_token?: string
    microsoft_code?: string
    microsoft_access_token?: string
  }) => {
    setLoading(true)
    setError(null)

    try {
      const validToken = await ensureValidToken()

      await api.post('/user/providers/connect', data, {
        headers: {
          Authorization: `Bearer ${validToken}`
        }
      })

      setLoading(false)
      return true
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to connect provider')
      setLoading(false)
      return false
    }
  }

  return { connectProvider, error, loading }
}

export default useConnectProvider
